import { gql, useMutation } from '@apollo/client'
import { IForumPost, IForumPostCreateInput } from '@dtos/Comment'

export const FORUM_POST_CREATE = gql`
  mutation ForumPostCreate($topicId: ID!, $body: String!) {
    forumPostCreate(
      input: {
        topicId: $topicId
        body: $body
        clientMutationId: "forum-post-create"
      }
    ) {
      post {
        id
        body
        createdAt
        user {
          id
          fullName
          firstName
          lastName
          email
          avatarUrl
        }
      }
      errors
    }
  }
`

interface IForumPostCreateResult {
  forumPostCreate: {
    post: IForumPost | null
    errors: string[]
  }
}

export const useForumPostCreate = () => {
  const [createPost, { loading, error }] = useMutation<IForumPostCreateResult>(
    FORUM_POST_CREATE,
    {
      refetchQueries: ['GetForumTopic', 'GetForumTopics'],
      awaitRefetchQueries: true,
    },
  )

  const handleCreatePost = async (input: IForumPostCreateInput) => {
    const response = await createPost({ variables: input })
    return response.data?.forumPostCreate
  }

  return { handleCreatePost, loading, error }
}
